import React from 'react';
import { Create } from 'react-admin';

import AccionForm from '../../Acciones/AccionForm';

function AccionBorradorCreate(props) {
  return (
    <Create {...props}>
      <AccionForm draft />
    </Create>
  );
}

export default AccionBorradorCreate;
